<template>
  <div class="row items-center q-mb-md user-profile-avatar" aid="user-profile-avatar">
    <div class="col-2">
      <div>
        <q-icon class="avatar" :class="{ 'new-background': useNewBackground }" size="80px">
          <span class="icon-letter">{{ initialEmailLetter }}</span>
        </q-icon>
      </div>
    </div>
    <div class="col-10">
      <div class="row text-subtitle1 q-pb-md">Email</div>
      <div class="row email">{{ email }}</div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, type PropType } from "vue";

export default defineComponent({
  name: "user-profile-avatar",
  props: {
    email: {
      type: String as PropType<string>,
      required: true,
    },
    useNewBackground: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  computed: {
    initialEmailLetter(): string {
      return this.email?.substring(0, 1).toUpperCase() || "";
    },
  },
});
</script>

<style scoped lang="scss">
.user-profile-avatar {
  .icon-letter {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 40px;
    color: $white;
  }
  .avatar {
    background-color: $black-30;
    border-radius: 50%;
    font-style: normal;

    &.new-background {
      @include m-bg-menu-clr;
    }
  }
}
</style>
